const getHash = () =>
    Date.now().toString(36) + Math.random().toString(36).substring(2)
const state = {
    items: [],
    arranged_items: [],
    itemsChanged: false,
    itemDeleted: false,
    orderChanged: false,
}

const getOrderPricing = items => {
    
    return items.reduce(
        (_pricing, item) => {
          
            if (!item.deleted) {
                let itemCost = 0

                if (item.start_rental_at && item.actual_returned_at && item.actual_rental_rate) {
                    const date1 = new Date(item.actual_returned_at);
                    const date2 = new Date(item.start_rental_at);
                    const diff = Math.abs(date1.getTime() - date2.getTime());
                    const diffDays = ((Math.ceil(diff / (1000 * 3600 * 24))) - item.estimated_days_holiday) || 1; 
                   
                    itemCost =
                    parseFloat(item.actual_rental_rate*diffDays) || 0;
                } else {

                    itemCost =
                    parseFloat(item.estimated_rental_rate*(item.estimated_rental_days- item.estimated_days_holiday)) || 0;
                }
                _pricing.total += itemCost;
                _pricing.tax +=
                    (itemCost * (parseFloat(item.asset?.master_item?.type?.tax_rate ?? item.estimated_total_rental_tax) || 0)) / 100;

                // _pricing.tax +=
                //     (itemCost * (parseFloat(item.asset?.master_item?.type?.tax_rate) || 0)) / 100
            }
            return _pricing
        },
        { tax: 0, total: 0 }
    )
}

const getItems = (items, types, is_discount) => {
    return items.filter(x => {
        const itemType = types.find(y => y.id == x.order_item_type_id)
        if (is_discount) {
            return !x.deleted && !!itemType?.is_discount
        } else {
            return !x.deleted && !itemType?.is_discount
        }
    })
}

const getAdjustmentTotals = adjustmentItems => {
    const defaultTitle = 'Discount'
    let title = defaultTitle
    let description = defaultTitle
    return adjustmentItems.reduce(
        (_pricing, item, idx) => {
            if (!item.deleted) {
                let itemCost =
                    (parseFloat(item.price) || 0) *
                    (parseFloat(item.quantity) || 0)

                _pricing.total += itemCost
                _pricing.tax +=
                    (itemCost * (parseFloat(item.tax_rate) || 0)) / 100
                if (idx == 0) {
                    _pricing.title = item.name
                    _pricing.description = item.description
                } else {
                    _pricing.title = defaultTitle
                    _pricing.description = defaultTitle
                }
            }
            return _pricing
        },
        { tax: 0, total: 0, title, description }
    )
}

const getters = {
    orderPricing(state) {
        return getOrderPricing(state.items)
    },

    itemsTotals(state, getters) {
       // const types = rootState.itemType.items
        const primary_totals = getOrderPricing(getters['itemsOnly'])
        return {
            tax: primary_totals.tax,
            total: primary_totals.total,
        }
    },

    adjustmentTotals(state, getters) {
        // const types = rootState.itemType.items
        const { tax, total, title, description } = getAdjustmentTotals(
            getters['adjustmentItems']
        )
        return {
            tax: tax,
            total: total,
            title,
            description,
        }
    },

    itemsOnly(state) {
        return state.items
        // const types = rootState.itemType.items
        // return getItems(state.items, types, false)
    },

    adjustmentItems(state, getters, rootState) {
        const types = rootState.itemType.items
        return getItems(state.items, types, true)
    },

    hasPricing(state) {
        return !!state.items.length
    },
    orderTotal(state) {
        return getOrderPricing(state.items)
    },

    orderTax(state) {
        return getOrderPricing(state.items)
    },
}

const mutations = {
    SET_ITEMS(state, items) {
        console.log('the set item is called');
        state.items = items
        console.log('final state for item', state.items);
    },
    SET_CHANGED(state, x) {
        state.itemsChanged = x
    },
    SET_ITEM_DELETED(state, x) {
        state.itemDeleted = x
    },
    SET_ORDER_CHANGED(state, x) {
        state.orderChanged = x
    },
    ARRANGED_DATA(state, arranged_items) {
        state.arranged_items = arranged_items
    },
}

const actions = {
    load({ commit }, initialItems) {
        console.log('initialItems', initialItems)
        const items = initialItems.map(x => {
            x.hash = x.hash || getHash()
            return x
        })
        commit('SET_ITEMS', items)
        commit('SET_CHANGED', false)
        commit('SET_ITEM_DELETED', false)
    },

    clear({ commit }) {
        commit('SET_ITEMS', [])
        commit('SET_CHANGED', false)
        commit('SET_ITEM_DELETED', true)
    },

    merge({ state, commit }, item) {
        console.log('this is state',state.items);
        item.hash = item.hash || getHash()
        console.log('this item has hash',item.hash);
        const items = [...state.items]
        console.log('this item state is ',items);
        let index = items.findIndex(
            x => x.hash == item.hash || x.asset_id == item.asset_id
        )
       
        if (index >= 0) items.splice(index, 1, item)
        else items.push(item)
        console.log('this item to be stored',items);
        commit('SET_CHANGED', true)
        commit('SET_ITEMS', items)
    },

    delete({ state, commit }, hash) {
        const items = [...state.items]
        const index = items.findIndex(x => x.hash == hash)
        items.splice(index, 1)
        commit('SET_CHANGED', true)
        commit('SET_ITEMS', items)
        commit('SET_ITEM_DELETED', true)
    },
    deleteTemplate({commit}) {
        commit('SET_ITEMS', [])
    },
    async arrange(context, payload) {
        console.log('payLoad', payload)
        context.commit('SET_ORDER_CHANGED', true)
        context.commit('ARRANGED_DATA', payload)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
